module.exports = new __parcel__URL__("gold-coin.dabc275c.webp").toString();